import camelCase from 'lodash/camelCase';
import { GA_NAV_FROM_ATTRIBUTE } from '@common/Tracking';
import { findAncestor } from '@helpers/findAncestor';
import { get as getFromLs, remove as removeFromLs, set as setFromLs } from '@helpers/localStorage';
import TRACKER_DATA_ATTRIBUTES from './constants/TrackedDataAttr';

const findAndSet = (value) => {
    const navFrom = TRACKER_DATA_ATTRIBUTES[value];

    if (navFrom) {
        setFromLs('nav_from', navFrom);
    }
};

/**
 * Get nav_from from local storge.
 * Item has to be removed right after getting.
 *
 * @return {string|null}
 */
export const getNavFromValue = () => {
    const navFrom = getFromLs('nav_from');

    if (navFrom) {
        removeFromLs('nav_from');
        return decodeURIComponent(navFrom.replace(/"/g, ''));
    }

    return null;
};

export const setNavFromValue = (value, event) => {
    const eventType = event ? event.type : null;

    if (eventType === 'contextmenu') {
        window.temporaryNavFrom = getNavFromValue();
        findAndSet(value);

        if (window.temporaryNavFrom) {
            document.addEventListener('click',
                () => findAndSet(window.temporaryNavFrom),
                { once: true });
        }
    } else {
        findAndSet(value);
    }
};

const NavFromTracker = () => {
    const handleClick = (e) => {
        const targetHasValue = e.target.hasAttribute(GA_NAV_FROM_ATTRIBUTE);
        const dataSetKey = camelCase((GA_NAV_FROM_ATTRIBUTE).replace('data-', ''));
        const ancestorHasValue = findAncestor(e.target, dataSetKey);

        if (targetHasValue || !!ancestorHasValue) {
            const navFromValue = targetHasValue ? e.target.dataset[dataSetKey] : ancestorHasValue;
            findAndSet(navFromValue);
        }
    };

    const initEvent = () => {
        document.addEventListener('click', handleClick);
    };

    return {
        init: initEvent
    };
};

export default NavFromTracker();
